<template>
  <div class="position-relative mt-3" id="MappingTable">
    <div class="actions text-right" id="MappingTable-showAddEditDialog">
      <button class="btn btn-primary icon-button" @click="showAddEditDialog = true" id="MappingTable-add-Button">
        <span class="btn-icon" id="MappingTable-addButton-span"><i class="fa fa-plus" aria-hidden="true"
            id="MappingTable-addButton-data"></i></span>
        {{ 'ADD' | translate }}
      </button>
      <button class="btn btn-primary icon-button" @click="showAddExcelDialog = true" id="MappingTable-addExcel-Button">
        <span class="btn-icon" id="MappingTable-excel-span">
          <i class="fa fa-plus" aria-hidden="true" id="MappingTable-excel-data"></i>
        </span>
        {{ 'ADD_API_MAPPING' | translate }}
      </button>
    </div>

    <vodal :show="showAddEditDialog" :width="400" :closeOnEsc="true" :closeOnClickMask="false"
      :customStyles="{ 'top': '80px', 'bottom': 'auto', 'height': 'auto' }" animation="rotate" @hide="closeDialog">
      <mapping-add-edit-dialog :edited="editedRow" :productLineNames="productLineNames" @save="onSaveNew" 
        @update="onUpdate" @close="closeDialog" id="MappingTable-addEditDialog">
      </mapping-add-edit-dialog>
    </vodal>

    <vodal :show="showAddExcelDialog" :width="400" :closeOnEsc="true" :closeOnClickMask="false" 
      :customStyles="{ 'top': '80px', 'bottom': 'auto', 'height': 'auto' }" animation="rotate" @hide="closeExcelDialog">
      <add-excel-mapping @file-upload="onFileUpload" @close="closeExcelDialog" id="MappingTable-addExcelDialog">
      </add-excel-mapping>
    </vodal>
    <table class="table table-striped table-hover" id="MappingTable-tableData">
      <caption></caption>
      <tr>
        <th>Importlabel</th>
        <th>Mapping</th>
        <th>Product lines</th>
        <th></th>
      </tr>
      <template v-for="row in rows">
        <tr>
          <td :id="'MappingTable-checkboxs-' + row.label" class="table-cell">{{ row.label }}</td>
          <td :id="'MappingTable-checkboxs-' + row.value" class="table-cell">{{ row.value }}</td>
          <td :id="'MappingTable-checkboxs-' + row.value" class="table-cell" :checked="row.productLines">
            <div v-if="Array.isArray(row.productLines) && row.productLines.length > 0">
              <div v-if="row.productLines.length > 2" style="max-height: 50px; overflow-y: auto;">
                <div class="scrollable-div" title="Scroll for more" @click.stop>
                  <!-- Overlay -->
                  <div class="overlay" v-show="row.productLines.length > 2"></div>
                  <template v-for="(product, index) in row.productLines">
                    <div :key="index" class="product-item">
                      {{ product | translate('product') }}
                    </div>
                  </template>
                </div>
              </div>
              <div v-else>
                <div v-for="(product, index) in row.productLines" :key="index" class="product-item">
                  {{ product | translate('product') }}
                </div>
              </div>
            </div>
          </td>
          <td id="MappingTable-tableButtons">
            <button class="btn btn-success icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('EDIT')" @click="onEdit(row)" id="MappingTable-tableEditButton">
              <span class="btn-icon" id="MappingTable-tableEditSpan"><i class="fa fa-pencil" aria-hidden="true"
                  id="MappingTable-tableEditData"></i></span>
            </button>
            <button class="btn btn-danger icon-button icon-button-collapsed"
              v-tooltip="$options.filters.translate('DELETE')" @click="confirmDelete(row)"
              id="MappingTable-tableDeleteButton">
              <span class="btn-icon" id="MappingTable-tableDeleteSpan"><i class="fa fa-trash-o" aria-hidden="true"
                  id="MappingTable-tableDeleteData"></i></span>
            </button>
          </td>
        </tr>
      </template>
    </table>
    <confirm-dialog :show="showDeleteConfirmDialog" :textLabel="'Are you sure you want to delete this?'"
            @hide-dialog="showDeleteConfirmDialog = false" @confirm="onRemove(selectedRow.id)">
            </confirm-dialog>
  </div>
</template>

<script>
import RestService from '../../../service/RestService.js';
import MappingAddEditDialog from './MappingAddEditDialog';
import AddExcelMapping from './MappingExcelDialog';
import Datepicker from 'vuejs-datepicker';
import Vodal from 'vodal';
import ConfirmDialog from '../../dialog/ConfirmDialog.vue';

export default {
  components: { MappingAddEditDialog, AddExcelMapping, Datepicker, Vodal, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      filter: '',
      productLineNames: [],
      rows: [],
      newRows: [],
      editedRow: null,
      showAddEditDialog: false,
      showAddExcelDialog: false,
      showDeleteConfirmDialog: false,
      selectedRow: null
    }
  },
  beforeMount() {
    this.loadRows();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadRows() {
      const mappingResponse = await this.rest.getAllMappingRows();
      this.productLineNames = await this.rest.getAllProductlineRows().then(pl => pl.data.map(row => row.name));
      this.rows = mappingResponse.data;
    },
    async onSaveNew(row) {
      await this.rest.createMappingRow(row);
      this.closeDialog();
      this.loadRows();
    },
    async onUpdate(row) {
      await this.rest.updateMappingRow(row);
      this.closeDialog();
      this.loadRows();
    },
    onEdit(row) {
      this.editedRow = row;
      this.showAddEditDialog = true;
    },
    onRemove(rowId) {
      this.rows = this.rows.filter(row => row.id !== rowId);
      this.rest.deleteMappingRow(rowId);
      this.showDeleteConfirmDialog = false;
    },
    closeDialog() {
      this.showAddEditDialog = false;
      this.editedRow = null;
    },
    closeExcelDialog() {
      this.showAddExcelDialog = false;
    },
    async onFileUpload(file) {
      const formData = new FormData();
      formData.append('file', file);
      try {
        await this.rest.createExcelMappingRow(formData);
        await this.loadRows();
        this.closeExcelDialog();
      } catch (error) {
        const errorMessage = error.response.data || 'Invalid data in Excel.';
        this.$notify({
          type: 'alert-danger',
          duration: -1,
          text: errorMessage
        });
        this.$log.error(error);
      }
    },
    confirmDelete(row) {
      this.selectedRow = row;
      this.showDeleteConfirmDialog = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.actions {
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 0;

  .icon-button {
    padding-right: 15px;
    padding-left: 50px;
  }
}

.table-cell {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  max-width: fit-content;
}

.table {
  table-layout: fixed;
  width: 100%;
}

.table td {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/mapping/MappingTable.vue